import { Injectable, inject, signal } from '@angular/core';
import { accessControlConstants, assetScriptUrl } from '../constants/access-control-constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, of, take } from 'rxjs';
import { Utilities } from '../utils/utilities';

@Injectable({
  providedIn: 'root'
})
export class AccessControlService {
  httpClient = inject(HttpClient);
  util = inject(Utilities);
  router = inject(Router);
  fieldAccess$ = signal<any>({});
  userActionAccess$ = signal<any>({});
  pageAccess$ = signal<any>({});
  pageType: string = '';
  redirectUrl: string = '';

  getFieldAccess(forFeat?: string | null, resolver?: boolean): Observable<any> {
    const jsonUrl = assetScriptUrl + (forFeat ?? this.pageType) + '-' + accessControlConstants.fieldAccessJson;
    const params = new HttpParams().set('headerNotRequired', true).set('resolver', true);
    if (resolver)
      return this.httpClient.get(jsonUrl, { params });
    else
      this.httpClient.get(jsonUrl, { params }).subscribe({
        next: (res: any) => this.fieldAccess$.update(fields => ({ ...fields, [forFeat ?? this.pageType]: res })),
        error: (err) => console.log('errr', err)
      })
    return of(null);
  }

  getUserActionAccess(forFeat?: string | null, resolver?: boolean): Observable<any> {
    const jsonUrl = assetScriptUrl + (forFeat ?? this.pageType) + '-' + accessControlConstants.userActionAccessJson;
    const params = new HttpParams().set('headerNotRequired', true).set('resolver', true);
    if (resolver)
      return this.httpClient.get(jsonUrl, { params });
    else
      this.httpClient.get(jsonUrl, { params }).subscribe({
        next: (res: any) => this.userActionAccess$.update(userAction => ({ ...userAction, [forFeat ?? this.pageType]: res })),
        error: (err) => console.log('errr', err)
      })
    return of(null);
  }

  getPageAccess(overridePageType?: string): Observable<any> {
    const params = new HttpParams().set('headerNotRequired', true);
    const jsonUrl = assetScriptUrl + (overridePageType ?? this.pageType) + '-' + accessControlConstants.pageAccessJson;
    return this.httpClient.get(jsonUrl, { params }).pipe(take(1));
  }

  pageAccessCheck(pageUrl: string) {
    const splitedUrl = pageUrl?.split('/');
    this.pageType = '';
    if (pageUrl?.toLowerCase()?.includes('availability'))
      this.pageType = 'availabilities';
    else if (pageUrl?.toLowerCase()?.includes('-course'))
      this.pageType = (splitedUrl?.length > 2 && splitedUrl[2] === '1') ? 'general-course' : 'course';
    else if (pageUrl?.toLowerCase()?.includes('department'))
      this.pageType = 'department';
    else if (pageUrl?.toLowerCase()?.includes('intake') || pageUrl?.toLowerCase()?.includes('view-intl-notes'))
      this.pageType = 'intake';
    else if (pageUrl?.toLowerCase()?.includes('campus'))
      this.pageType = 'campus';
    else if (pageUrl?.toLowerCase()?.includes('-er'))
      this.pageType = 'er';
    else if (pageUrl?.toLowerCase()?.includes('institution'))
      this.pageType = 'institution';
    else if (pageUrl?.toLowerCase()?.includes('subject-classification'))
      this.pageType = 'subject-classification';
    else if (pageUrl?.toLowerCase()?.includes('clearing'))
      this.pageType = 'general-course';
    else if (pageUrl?.toLowerCase()?.includes('non-edu-org'))
      this.pageType = 'non-edu-org';
    else if (pageUrl?.toLowerCase()?.includes('forward-generation'))
      this.pageType = 'forward-generation';
    else if (pageUrl?.toLowerCase()?.includes('manage-report'))
      this.pageType = 'report-extraction';
    return this.pageType in this.pageAccess$()
  }

  getRedirectUrl(pageUrl: string) {
    const userRole = this.util.getStoredUserDetails()?.roleName ?? '';
    const pageAccesssData = this.pageAccess$()[this.pageType][userRole];
    if (pageAccesssData) {
      let pageName = Object.keys(pageAccesssData)?.find((access) => pageUrl?.includes(access) && pageAccesssData[access]);
      if (localStorage.getItem("institutionDetails") && pageName && pageUrl.includes('add-course/2'))
        pageName = JSON.parse(localStorage.getItem("institutionDetails") ?? '')?.eflCoursesAvailability;
      const redirectUrl = !pageName ? this.fecthRedirectUrl() : '';
      return redirectUrl;
    }
    return '';
  }

  fecthRedirectUrl() {
    const pageTypes = ['course', 'general-course', 'department', 'intake', 'campus', 'institution', 'non-edu-org'];
    if (pageTypes?.includes(this.pageType)) return `manage-${this.pageType?.replace('general-', '')?.toLowerCase()}`;
    else if (this.pageType === 'er') return `manage-er/1`;
    else if (this.pageType === 'subject-classification') return 'home';
    else if (['report-extraction', 'forward-generation'].includes(this.pageType))
      if (JSON.parse(localStorage.getItem("institutionDetails") ?? '')?.institutionId)
        return `edit-institution/${JSON.parse(localStorage.getItem("institutionDetails") ?? '')?.institutionId}`;
      else
        return 'home';
    return ''
  }

  getAccessData(forFeat?: string) {
    if (!(this.pageType in this.fieldAccess$()))
      this.getFieldAccess(forFeat, false);
    if (!(this.pageType in this.userActionAccess$()))
      this.getUserActionAccess(forFeat, false);
  }
}
